import { toast as _toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export type ToastType = 'success' | 'error';

export const toast = (message: string, type: ToastType = 'success'): string | number => {
    return _toast[type](message, {
        pauseOnHover: false,
        autoClose: 3000,
        toastId: message,
    }) as string;
};
